var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "review-step" },
    [
      _c("div", { staticClass: "review-section" }, [
        _c("p", { staticClass: "fm-section-label" }, [_vm._v("Loan Summary")]),
        _vm._v(" "),
        _c("div", { staticClass: "review-grid" }, [
          _c("div", { staticClass: "review-item" }, [
            _c("span", { staticClass: "review-item__label" }, [
              _vm._v("Amount"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "review-item__value" }, [
              _vm._v(_vm._s(_vm.readonlyInfo.loan.amount)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "review-item" }, [
            _c("span", { staticClass: "review-item__label" }, [
              _vm._v("Duration"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "review-item__value" }, [
              _vm._v(
                _vm._s(_vm.readonlyInfo.loan.terms) +
                  " Month" +
                  _vm._s(_vm.readonlyInfo.loan.terms > 1 ? "s" : "")
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "review-item" }, [
            _c("span", { staticClass: "review-item__label" }, [_vm._v("Type")]),
            _vm._v(" "),
            _c("span", { staticClass: "review-item__value" }, [
              _vm._v(_vm._s(_vm.readonlyInfo.loan.type)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "review-item" }, [
            _c("span", { staticClass: "review-item__label" }, [
              _vm._v(
                _vm._s(_vm._f("capitalize")(_vm.readonlyInfo.loan.frequency)) +
                  " Repayment"
              ),
            ]),
            _vm._v(" "),
            _vm.repaymentAmount !== null
              ? _c(
                  "span",
                  {
                    staticClass:
                      "review-item__value review-item__value--highlight",
                  },
                  [
                    _vm._v(_vm._s(_vm.repaymentAmount) + " "),
                    _c("span", { staticClass: "review-item__approx" }, [
                      _vm._v("approx."),
                    ]),
                  ]
                )
              : _c("span", { staticClass: "review-item__value text-danger" }, [
                  _vm._v("Error"),
                ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "review-section review-section--fees" },
        [
          _c("p", { staticClass: "fm-section-label" }, [
            _vm._v(
              _vm._s(
                _vm.isSACC
                  ? "Mini Flash Loan Fees (SACC)"
                  : "Super Flash Loan Fees (MACC)"
              )
            ),
          ]),
          _vm._v(" "),
          _vm.isSACC
            ? [
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "fee-row fee-row--muted" }, [
                  _c("span", [_vm._v("Dishonour Fee")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    [
                      _c("Money", {
                        attrs: { amount: _vm.vars.dishonor_charge ?? 20 },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "fee-row fee-row--muted" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "span",
                    [
                      _c("Money", {
                        attrs: { amount: _vm.vars.default_charge ?? 5 },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            : [
                _vm._m(3),
                _vm._v(" "),
                _vm._m(4),
                _vm._v(" "),
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "fee-row fee-row--muted" }, [
                  _c("span", [_vm._v("Dishonour Fee")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    [
                      _c("Money", {
                        attrs: { amount: _vm.vars.dishonor_charge ?? 20 },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "fee-row fee-row--muted" }, [
                  _c("span", [_vm._v("Reschedule Fee")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    [
                      _c("Money", {
                        attrs: { amount: _vm.vars.reschedule_charge ?? 20 },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "review-section" }, [
        _c("p", { staticClass: "fm-section-label" }, [_vm._v("Your Details")]),
        _vm._v(" "),
        _c("div", { staticClass: "review-grid" }, [
          _c("div", { staticClass: "review-item" }, [
            _c("span", { staticClass: "review-item__label" }, [
              _vm._v("Full Name"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "review-item__value" }, [
              _vm._v(_vm._s(_vm.readonlyInfo.user.fullName)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "review-item" }, [
            _c("span", { staticClass: "review-item__label" }, [
              _vm._v("Date of Birth"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "review-item__value" }, [
              _vm._v(_vm._s(_vm.readonlyInfo.user.dob)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "review-item" }, [
            _c("span", { staticClass: "review-item__label" }, [
              _vm._v("Email"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "review-item__value" }, [
              _vm._v(_vm._s(_vm.readonlyInfo.user.email)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "review-item" }, [
            _c("span", { staticClass: "review-item__label" }, [
              _vm._v("Mobile"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "review-item__value" }, [
              _vm._v(_vm._s(_vm.readonlyInfo.user.mobile)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "review-item review-item--full" }, [
            _c("span", { staticClass: "review-item__label" }, [
              _vm._v("Address"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "review-item__value" }, [
              _vm._v(_vm._s(_vm.readonlyInfo.user.addresses[0])),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "review-section" }, [
        _c("p", { staticClass: "fm-section-label" }, [
          _vm._v("Banking Information"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "review-grid" }, [
          _c("div", { staticClass: "review-item" }, [
            _c("span", { staticClass: "review-item__label" }, [
              _vm._v("Account Name"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "review-item__value" }, [
              _vm._v(_vm._s(_vm.readonlyInfo.fundDistribution.name)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "review-item" }, [
            _c("span", { staticClass: "review-item__label" }, [_vm._v("BSB")]),
            _vm._v(" "),
            _c("span", { staticClass: "review-item__value" }, [
              _vm._v(_vm._s(_vm.readonlyInfo.fundDistribution.bsb)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "review-item" }, [
            _c("span", { staticClass: "review-item__label" }, [
              _vm._v("Account Number"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "review-item__value" }, [
              _vm._v(_vm._s(_vm.readonlyInfo.fundDistribution.number)),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "review-section" }, [
        _c("p", { staticClass: "fm-section-label" }, [
          _vm._v("Identity Verification"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "review-grid" },
          [
            _vm.readonlyInfo.idVerification.documentType === "passport"
              ? [
                  _c("div", { staticClass: "review-item" }, [
                    _c("span", { staticClass: "review-item__label" }, [
                      _vm._v("Passport Number"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "review-item__value" }, [
                      _vm._v(
                        _vm._s(_vm.readonlyInfo.idVerification.passport.number)
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "review-item" }, [
                    _c("span", { staticClass: "review-item__label" }, [
                      _vm._v("Country"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "review-item__value" }, [
                      _vm._v(
                        _vm._s(_vm.readonlyInfo.idVerification.passport.country)
                      ),
                    ]),
                  ]),
                ]
              : [
                  _c("div", { staticClass: "review-item" }, [
                    _c("span", { staticClass: "review-item__label" }, [
                      _vm._v("Licence Number"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "review-item__value" }, [
                      _vm._v(
                        _vm._s(_vm.readonlyInfo.idVerification.license.number)
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "review-item" }, [
                    _c("span", { staticClass: "review-item__label" }, [
                      _vm._v("Card Number"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "review-item__value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.readonlyInfo.idVerification.license.cardNumber
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "review-item" }, [
                    _c("span", { staticClass: "review-item__label" }, [
                      _vm._v("State"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "review-item__value" }, [
                      _vm._v(
                        _vm._s(_vm.readonlyInfo.idVerification.license.state)
                      ),
                    ]),
                  ]),
                ],
            _vm._v(" "),
            _vm.isAustralianCitizen
              ? [
                  _c("div", { staticClass: "review-item" }, [
                    _c("span", { staticClass: "review-item__label" }, [
                      _vm._v("Medicare Card"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "review-item__value" }, [
                      _vm._v(
                        _vm._s(_vm.readonlyInfo.idVerification.medicare.number)
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "review-item" }, [
                    _c("span", { staticClass: "review-item__label" }, [
                      _vm._v("Medicare Reference"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "review-item__value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.readonlyInfo.idVerification.medicare.reference
                        )
                      ),
                    ]),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _vm._m(6),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "review-declarations" },
        [
          _c("p", { staticClass: "fm-section-label" }, [
            _vm._v("Declarations & Consent"),
          ]),
          _vm._v(" "),
          _c("Checkbox", {
            attrs: {
              "error-container": _vm.errorContainerName,
              name: "declareAccurate",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ onClick }) {
                  return [
                    _c("div", { on: { click: onClick } }, [
                      _vm._v(
                        "I declare that the information I have provided is true and accurate."
                      ),
                    ]),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.form.declareAccurate,
              callback: function ($$v) {
                _vm.$set(_vm.form, "declareAccurate", $$v)
              },
              expression: "form.declareAccurate",
            },
          }),
          _vm._v(" "),
          _c("Checkbox", {
            attrs: {
              "error-container": _vm.errorContainerName,
              name: "consentThirdParty",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ onClick }) {
                  return [
                    _c("div", { on: { click: onClick } }, [
                      _vm._v(
                        "I confirm that I am authorised to provide the personal details presented and I consent to my information being checked via third party systems for identity confirmation."
                      ),
                    ]),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.form.consentThirdParty,
              callback: function ($$v) {
                _vm.$set(_vm.form, "consentThirdParty", $$v)
              },
              expression: "form.consentThirdParty",
            },
          }),
          _vm._v(" "),
          _c("Checkbox", {
            attrs: {
              "error-container": _vm.errorContainerName,
              name: "subscribeOffers",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ onClick }) {
                  return [
                    _c("div", { on: { click: onClick } }, [
                      _vm._v(
                        "\n          I would like to hear from Flash Money about loan offers and debt management services that may interest me.\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.form.subscribeOffers,
              callback: function ($$v) {
                _vm.$set(_vm.form, "subscribeOffers", $$v)
              },
              expression: "form.subscribeOffers",
            },
          }),
          _vm._v(" "),
          _c("Checkbox", {
            attrs: {
              "error-container": _vm.errorContainerName,
              name: "agreeTermsAndConditions",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ onClick }) {
                  return [
                    _c("div", { on: { click: onClick } }, [
                      _vm._v(
                        "\n          I agree to the Terms and Conditions of\n          "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "review-link",
                          attrs: {
                            href: "/docs/Flash Money Direct Debit Authority & Service Agreement.pdf",
                            target: "_blank",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "Flash Money's Direct Debit Request and Service Agreement"
                          ),
                        ]
                      ),
                      _vm._v(".\n        "),
                    ]),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.form.agreeTermsAndConditions,
              callback: function ($$v) {
                _vm.$set(_vm.form, "agreeTermsAndConditions", $$v)
              },
              expression: "form.agreeTermsAndConditions",
            },
          }),
          _vm._v(" "),
          _c("Checkbox", {
            attrs: { "error-container": _vm.errorContainerName, name: "legal" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ onClick }) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex flex-column",
                        staticStyle: { gap: "6px" },
                        on: { click: onClick },
                      },
                      [
                        _c("strong", [_vm._v("Legal Declaration")]),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticStyle: { margin: "0", "font-size": "13px" } },
                          [
                            _vm._v(
                              "\n            I acknowledge that a person who commits fraud by deception or makes a false document is guilty of a\n            criminal offence and will be referred to the relevant law enforcement authority and criminally prosecuted.\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticStyle: { margin: "0", "font-size": "13px" } },
                          [
                            _vm._v(
                              "\n            I solemnly declare that all information provided in my application to Flash Money Pty Ltd is truthful,\n            correct and accurate.\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.form.legal,
              callback: function ($$v) {
                _vm.$set(_vm.form, "legal", $$v)
              },
              expression: "form.legal",
            },
          }),
          _vm._v(" "),
          _c("Checkbox", {
            attrs: {
              "error-container": _vm.errorContainerName,
              name: "jurisdiction",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ onClick }) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex flex-column",
                        staticStyle: { gap: "6px" },
                        on: { click: onClick },
                      },
                      [
                        _c("strong", [_vm._v("Jurisdiction")]),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticStyle: { margin: "0", "font-size": "13px" } },
                          [
                            _vm._v(
                              "\n            All parties agree that the courts of New South Wales, Australia shall have exclusive jurisdiction to\n            settle any dispute arising in connection with this agreement.\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.form.jurisdiction,
              callback: function ($$v) {
                _vm.$set(_vm.form, "jurisdiction", $$v)
              },
              expression: "form.jurisdiction",
            },
          }),
          _vm._v(" "),
          _c("Checkbox", {
            attrs: {
              "error-container": _vm.errorContainerName,
              name: "privacyPolicy",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ onClick }) {
                  return [
                    _c("div", { on: { click: onClick } }, [
                      _vm._v("\n          I have reviewed the\n          "),
                      _c(
                        "a",
                        {
                          staticClass: "review-link",
                          attrs: {
                            href: "/docs/Privacy Policy - Credit Providers (APP entities).pdf",
                            target: "_blank",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        [_vm._v("Privacy Policy")]
                      ),
                      _vm._v(
                        "\n          and I understand and accept all terms it sets out.\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.form.privacyPolicy,
              callback: function ($$v) {
                _vm.$set(_vm.form, "privacyPolicy", $$v)
              },
              expression: "form.privacyPolicy",
            },
          }),
          _vm._v(" "),
          _c("Checkbox", {
            attrs: {
              "error-container": _vm.errorContainerName,
              name: "acknowledgementAndConsent",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ onClick }) {
                  return [
                    _c("div", { on: { click: onClick } }, [
                      _vm._v(
                        "\n          I have read and understood the\n          "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "review-link",
                          attrs: {
                            href: "/docs/Acknowledgement and Consent.pdf",
                            target: "_blank",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        [_vm._v("Acknowledgement and Consent")]
                      ),
                      _vm._v(
                        "\n          and make all consents it contains, including consenting to: electronic identity verification, promotion of\n          products and services, information exchange with other providers, and a credit check.\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.form.acknowledgementAndConsent,
              callback: function ($$v) {
                _vm.$set(_vm.form, "acknowledgementAndConsent", $$v)
              },
              expression: "form.acknowledgementAndConsent",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("controls", null, null, { prev: _vm.onPrev, next: _vm.onNext }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "fee-row" }, [
      _c("span", [
        _vm._v("Establishment Fee "),
        _c("span", { staticClass: "fee-note" }, [_vm._v("once off per loan")]),
      ]),
      _vm._v(" "),
      _c("strong", [_vm._v("20% of principal")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "fee-row" }, [
      _c("span", [
        _vm._v("Monthly Loan Fee "),
        _c("span", { staticClass: "fee-note" }, [
          _vm._v("per month while balance outstanding"),
        ]),
      ]),
      _vm._v(" "),
      _c("strong", [_vm._v("4% of principal/month")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("Default Fee "),
      _c("span", { staticClass: "fee-note" }, [_vm._v("daily")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "fee-row" }, [
      _c("span", [_vm._v("Establishment Fee")]),
      _vm._v(" "),
      _c("strong", [_vm._v("$400.00")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "fee-row" }, [
      _c("span", [_vm._v("Interest Rate (APR)")]),
      _vm._v(" "),
      _c("strong", [_vm._v("47.6158% p.a.")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "fee-row" }, [
      _c("span", [_vm._v("Comparison Rate")]),
      _vm._v(" "),
      _c("strong", [_vm._v("65.6597% p.a.")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "review-legal-note" }, [
      _vm._v(
        "\n      This guide does not constitute legal advice. Before making a decision, visit\n      "
      ),
      _c(
        "a",
        { attrs: { href: "https://moneysmart.gov.au/", target: "_blank" } },
        [_vm._v("moneysmart.gov.au")]
      ),
      _vm._v(" or speak to your financial advisor.\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }